import React, { useContext, useEffect } from "react";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AuthContext from "../../context/auth/authContext";
import Destinations from "../destination/Destinations";
import Trips from "../trips/Trips";

const Destination = () => {

  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Discover
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Explore destinations around the world and discover trips shared by travelers.
        </Typography>
      </Box>
      <Destinations />
      <Box sx={{ mt: 5, mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Recent Trips
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          See what others have been up to lately.
        </Typography>
      </Box>
      <Trips />
    </Box>
  );
};

export default Destination;
